import {
    UPLOADING_MEDIA_REQUEST,
    UPLOADING_MEDIA_SUCCEEDED,
    UPLOADING_MEDIA_FAILED,
  } from "./actionTypes";
  import axios from "axios";

  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  const UPLOADING_MEDIA_BASE_URL = `${apiUrl}/api/2.0/media/upload`;

  //Uploading Media
  export function uploadMedia(info, file, dimensions) {
    return function (dispatch) {
      dispatch(uploadingMediaRequest(info.signedUrl, file, dimensions));
      const request = {
        fileName: file.name,
        signedUrl: info.signedUrl,
        file: file,
        width: dimensions.width,
        height: dimensions.height,
      };
  
      return axios({
        method: "POST",
        url: UPLOADING_MEDIA_BASE_URL,
        data: request,
      })
        .then((response) =>
          dispatch(
            uploadingMediaSucceeded(info.signedUrl, file, response.data, {
              width: file.width,
              height: file.height,
            })
          )
        )
        .catch((error) =>
          dispatch(uploadingMediaFailed(info.signedUrl, file, error))
        );
    };
    function uploadingMediaRequest() {
      return {
        type: UPLOADING_MEDIA_REQUEST,
        payload: {},
      };
    }
  
    function uploadingMediaSucceeded(signedUrl, file, image, dimensions) {
      return {
        type: UPLOADING_MEDIA_SUCCEEDED,
        payload: {
          file: file,
          url: signedUrl,
          image: image,
          width: dimensions.width,
          height: dimensions.height,
        },
      };
    }
  
    function uploadingMediaFailed(error) {
      return {
        type: UPLOADING_MEDIA_FAILED,
        payload: {
          error: error,
        },
      };
    }
  }